import { UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { TASK_CATEGORY } from "../apiRoutes";

// Define the expected response type (adjust based on your API response)
interface TaskCategory {
  name: string;
  description: string;
  createdAt: string;
  isActive: boolean;
}

interface TaskCategoryResponse {
  data: {
    records: TaskCategory[];
    pagination: { totalRecords: number }[];
  }[];
}


const fetchTaskCategory = async ({ data }: { data: FieldValues }) => {
  const response = await axiosAuth.get<TaskCategoryResponse>(TASK_CATEGORY, {
    params: data,
  });
  return response.data;
};

// Query hook
const useTaskCategoryQuery = (
  data: FieldValues,
  queryParams?:
    | UseQueryOptions<TaskCategoryResponse, Error, TaskCategoryResponse, ["taskCategory", FieldValues]>
    | UseMutationOptions<any, Error>
) =>
  useQuery<TaskCategoryResponse, Error, TaskCategoryResponse, ["taskCategory", FieldValues]>({
    queryKey: ["taskCategory", data],
    queryFn: () => fetchTaskCategory({ data }),
    ...(queryParams as any), // safely spread because TS can’t know if it's query or mutation
  });

export default useTaskCategoryQuery;
